<a class="info p-0" data-original-title="" title="" (click)="editRoute(idEntity)">
    <i class="icon-pencil font-small-3 mr-2"></i>
</a>
